import { syncDirtyBudgets } from "containers/Budget/_actions";
import ReactGA from "react-ga4";

const actionTypes = {
    SOIL_TEST_ADD: "SOIL_TEST_ADD",
    SOIL_TEST_DELETE: "SOIL_TEST_DELETE",
};

export default actionTypes;

export function saveSoilTest(farmId, budgetId, soilTests, blocks) {
    ReactGA.event({
        category: "Soil Test",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.SOIL_TEST_ADD, payload: { farmId, budgetId, soilTests, blocks } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteSoilTest(farmId, budgetId, soilTestsId) {
    ReactGA.event({
        category: "Soil Test",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.SOIL_TEST_DELETE, payload: { farmId, budgetId, soilTestsId } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}
